import { mapActions, mapState } from 'vuex';
import { pluralize } from '@/utils/strings';

export const trash = {
	data() {
		return {
			isTrashing: false,
			isBulkTrashing: false,
		};
	},
	computed: {
		...mapState('campaigns', ['bulk']),
	},
	methods: {
		...mapActions('campaigns', ['trashCampaign', 'bulkTrashCampaigns', 'deleteSplitCampaign']),
		bulktrashing(status) {
			this.isBulkTrashing = status;
		},
		trash() {
			const message = this.campaign.is_split
				? `The ${this.campaign.name} campaign was deleted successfully.`
				: `The ${this.campaign.name} campaign was sent to the trash successfully.`;

			const action = this.campaign.is_split ? 'deleteSplitCampaign' : 'trashCampaign';

			this.isTrashing = true;

			this[action](this.campaign)
				.then(() => {
					this.$store.commit('campaigns/addAlert', { message, type: 'success' });
				})
				.finally(() => {
					this.isTrashing = false;
					this.$modal.hide(`${this.campaign.id}-trash-modal`);
				});
		},
		bulkTrash() {
			this.isBulkTrashing = true;
			const count = this.bulk.length;

			this.bulkTrashCampaigns({ campaigns: this.bulk })
				.then(() => {
					const message = `Successfully trashed ${count} ${pluralize('campaign', count)}.`;
					this.$store.commit('campaigns/addAlert', { message, type: 'success' });
				})
				.finally(() => {
					this.isBulkTrashing = false;
					this.$modal.hide('bulk-trash-modal');
				});
		},
	},
};
